import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import React from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Search from '@material-ui/icons/Search';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Avatar from '@material-ui/core/Avatar';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { format, parse, subMonths } from 'date-fns';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import PensionistaService from '../../services/PensionistaService';
import TablePaginationActions from '../share/TablePaginationActions';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { Link } from 'react-router-dom';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    margin: theme.spacing.unit / 2,
    padding: theme.spacing.unit / 2,
  },
  container: {
    display: 'block',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 320,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  button: {
    margin: theme.spacing.unit,
  },
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  badge: {
    top: 1,
    right: -15,
    border: `2px solid ${
      theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[900]
    }`,
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});

class FluxoPensionista extends React.Component {
  pensionistaService = new PensionistaService();

  state = {
    tipo: 1,
    from: format(subMonths(new Date(), 12), 'YYYY-MM-DD'),
    to: format(new Date(), 'YYYY-MM-DD'),
    fluxo: [],
    fetching: false,
    page: 0,
    rowsPerPage: 5,
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  consultarFluxo = async (filter) => {
    const pensionistas = await this.pensionistaService.consultarFluxo(filter);
    this.setState({fluxo: pensionistas, fetching: false});
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleClick = (event) => {
    event.preventDefault();
    const { tipo, from, to } = this.state;
    this.setState({fluxo: [], fetching: true});
    this.consultarFluxo({
      tipo: tipo,
      from: from === '' ? parse(new Date(0)) : parse(from),
      to: to === '' ? parse(new Date()) : parse(to)}
    );
  };

  render () {
    const { classes } = this.props;
    const { tipo, from, to, fluxo, fetching, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, fluxo.length - page * rowsPerPage);

    return (
      <React.Fragment>
        <Link to='/consulta' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Pensionistas Cadastrados na CIF</Typography>
              <Avatar className={classes.avatar}>{fluxo.length}</Avatar>
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor='tipo-simple'>Cadastrados ou Cancelados</InputLabel>
              <Select
                autoFocus
                value={tipo}
                onChange={this.handleChange}
                inputProps={{
                  name: 'tipo',
                }}
              >
                <MenuItem value={1}>Pensionistas Cadastrados</MenuItem>
                <MenuItem value={2}>Pensionistas Cancelados</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id='date'
              label='De'
              type='date'
              value={from}
              onChange={this.handleChange}
              inputProps={{
                name: 'from',
              }}
              className={classes.textField}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <TextField
              id='date'
              label='Até'
              className={classes.textField}
              type='date'
              value={to}
              onChange={this.handleChange}
              inputProps={{
                name: 'to',
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Button
              variant='extendedFab'
              aria-label='Consultar'
              type='submit'
              onTouchStart={this.handleClick}
              onClick={this.handleClick}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Button>
          </form>
        </Paper>
        {fluxo.length > 0
          ? <Paper className={classes.root}>
            <div className={classes.tableWapper}>
              <Table padding='default'>
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Sexo</TableCell>
                    <TableCell>Data de nascimento</TableCell>
                    <TableCell>Data da Situação</TableCell>
                    <TableCell>Ocorrencia</TableCell>
                    <TableCell>Participa do TST-Saúde (mat. antiga)?</TableCell>
                    <TableCell>Já possui matrícula nova?</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {fluxo.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((pensionista, idx) => {
                    return (
                      <TableRow key={idx}>
                        <TableCell>{pensionista.codPensionista}</TableCell>
                        <TableCell component='th' scope='row'>{pensionista.nome}</TableCell>
                        <TableCell>{pensionista.sexo}</TableCell>
                        <TableCell>{pensionista.dtaNascimento}</TableCell>
                        <TableCell>{format(new Date(pensionista.dtaInicio), 'DD/MM/YYYY')}</TableCell>
                        <TableCell>{pensionista.ocorrencia}</TableCell>
                        <TableCell>{pensionista.indCadastroPensionistaAntigo}</TableCell>
                        <TableCell>{pensionista.indNovoCadastroPensionista}</TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 48 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      colSpan={12}
                      count={fluxo.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </Paper>
          : <Paper className={classes.root} elevation={1}>
            {fetching ? <LinearProgressBlockScreen />
              : <Typography component='p'>
                Selecione o tipo de consulta e o período que deseja buscar
              </Typography>
            }
          </Paper>
        }
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(FluxoPensionista);
